import { Auth } from 'aws-amplify';

export async function getCurrentAccessToken(): Promise<string | null> {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch {
    return null;
  }
}
